(function(){"use strict";
var CFG = {"caminho":null,"alvo":"^/(products/[^/]+|pages/(?!abcd-bandle)[^/]+)$","braco":"D","rotulo":"rollout-tudo-v3","pagina":"lencol","produtos":null,"props":null,"unidade":["item","itens"],"nome":null,"composicao":null,"cabecalho":"tema"};
var CSS_PAINEL = ".hb-root{--bg:#F4F6F9;--surf:#FFFFFF;--ink:#1D2430;--ink2:#333C5E;--mute:#4D5878;--line:#E1E6EF;--line2:#EDF0F5;--chip:#FFFFFF;--acc:#0094FF;--ok:#12805C;--bad:#C0392B;--mono:ui-monospace,SFMono-Regular,\"SF Mono\",Menlo,monospace;--sans:\"Poppins\",system-ui,-apple-system,\"Segoe UI\",sans-serif}.hb-root *{box-sizing:border-box}.hb-root .hb-pt{padding:0;overflow:hidden}.hb-root .hb-pt{--p-ink:#1D2430;--p-ink2:#333C5E;--p-mute:#4D5878;--p-faint:#8892A8;--p-line:#E4E9F1;--p-line2:#EFF2F7;--p-grey:#F2F2F2;--p-tint:#E9F4FE;--p-warn:#FBF4E1;--p-warn-ink:#7A5A12;--p-navy:#333C5E;--p-blue:#0094FF;--p-blue-ink:#FFFFFF;container-type:inline-size;background:#FFFFFF;color:var(--p-ink);border:1px solid var(--p-line);border-radius:14px;font-family:var(--sans);font-size:14px;line-height:1.45;box-shadow:0 1px 2px rgba(29,36,48,.05),0 12px 32px -18px rgba(29,36,48,.22);position:relative}.hb-root .hb-pt *{box-sizing:border-box}.hb-root .hb-pt button{font:inherit;color:inherit;background:transparent;border:0;padding:0;cursor:pointer;text-align:left}.hb-root .hb-pt button:focus-visible{outline:2px solid var(--p-blue);outline-offset:2px;border-radius:4px}.hb-root .hb-pt hr{border:0;border-top:1px solid var(--p-line2);margin:16px 0}.hb-root .hb-pt-pad{padding:22px}.hb-root .hb-pt h2{font-size:20px;line-height:1.25;font-weight:700;letter-spacing:-.02em;margin:0;text-wrap:balance}.hb-root .hb-pt .hb-money{font-weight:800;letter-spacing:-.02em;font-variant-numeric:tabular-nums}.hb-root .hb-pt .hb-old{color:var(--p-faint);text-decoration:line-through;font-weight:500;font-variant-numeric:tabular-nums}.hb-root .hb-pt .hb-strip{display:flex;gap:9px;align-items:flex-start;border-radius:9px;padding:10px 12px;font-size:11.5px;line-height:1.45}.hb-root .hb-pt .hb-strip-warn{background:var(--p-warn);color:var(--p-warn-ink)}.hb-root .hb-pt .hb-strip b{font-weight:700}.hb-root .hb-pt .hb-thumb{display:block;width:42px;height:42px;border-radius:8px;border:1px solid var(--p-line);background-size:cover;background-position:center;flex:0 0 auto}.hb-root .hb-pt .hb-cta{display:block;width:100%;background:var(--p-blue);color:var(--p-blue-ink);font-size:14.5px;font-weight:700;text-align:center;padding:15px 16px;border-radius:9px;letter-spacing:-.01em;transition:filter .12s}.hb-root .hb-pt .hb-cta:hover{filter:brightness(.94)}.hb-root .hb-pt .hb-addon{display:flex;align-items:center;gap:11px;width:100%;border:1px solid var(--p-line);border-radius:10px;padding:10px 12px;margin-top:8px;background:#fff}.hb-root .hb-pt .hb-addon[aria-pressed=\"true\"]{background:#F7F9FC;border-color:#CFD9E8}.hb-root .hb-pt .hb-box{width:18px;height:18px;border-radius:5px;border:1.5px solid #C3CDDD;flex:0 0 auto;display:grid;place-items:center;color:#fff;font-size:11px;font-weight:800;background:#fff}.hb-root .hb-pt .hb-addon[aria-pressed=\"true\"] .hb-box{background:var(--p-blue);border-color:var(--p-blue)}.hb-root .hb-pt .hb-addon .hb-an{font-size:12.5px;font-weight:500;color:var(--p-ink2);flex:1 1 auto}.hb-root .hb-pt .hb-addon .hb-ap{display:flex;gap:7px;align-items:baseline;flex:0 0 auto}.hb-root .hb-pt .hb-addon .hb-ap .hb-money{font-size:13px}.hb-root .hb-pt .hb-addon .hb-ap .hb-old{font-size:11px}.hb-root .hb-pt .hb-selwrap{display:flex;gap:7px;flex:1 1 auto;min-width:0}.hb-root .hb-pt select{font:inherit;font-size:11.5px;color:var(--p-ink2);background:#fff;border:1px solid var(--p-line);border-radius:7px;padding:6px 8px;width:100%;min-width:0;appearance:none;background-image:linear-gradient(45deg,transparent 50%,#98A3B8 50%),linear-gradient(135deg,#98A3B8 50%,transparent 50%);background-position:calc(100% - 13px) 52%,calc(100% - 9px) 52%;background-size:4px 4px,4px 4px;background-repeat:no-repeat}.hb-root .hb-pt ul{list-style:none;margin:0;padding:0}.hb-root .hb-pt .hb-offer{border:1.5px solid var(--p-line);border-radius:12px;background:#fff;overflow:hidden;position:relative;margin-top:9px}.hb-root .hb-pt .hb-offer[data-sel=\"1\"]{border-color:var(--p-blue);border-width:2px}.hb-root .hb-pt .hb-offer .hb-ohead{display:flex;align-items:center;gap:10px;padding:13px 14px}.hb-root .hb-pt .hb-radio{width:17px;height:17px;border-radius:50%;border:1.5px solid #C3CDDD;flex:0 0 auto;display:grid;place-items:center}.hb-root .hb-pt .hb-offer[data-sel=\"1\"] .hb-radio{border-color:var(--p-blue)}.hb-root .hb-pt .hb-offer[data-sel=\"1\"] .hb-radio::after{content:\"\";width:9px;height:9px;border-radius:50%;background:var(--p-blue)}.hb-root .hb-pt .hb-offer .hb-on{font-size:13.5px;font-weight:700;flex:1 1 auto}.hb-root .hb-pt .hb-offer .hb-on small{font-weight:500;font-size:10.5px;color:var(--p-mute);background:var(--p-grey);padding:3px 7px;border-radius:5px;margin-left:7px;white-space:nowrap}.hb-root .hb-pt .hb-offer .hb-op{text-align:right;flex:0 0 auto}.hb-root .hb-pt .hb-offer .hb-op .hb-money{font-size:15px;display:block}.hb-root .hb-pt .hb-offer .hb-op .hb-old{font-size:11px}.hb-root .hb-pt .hb-flag{position:absolute;top:0;right:0;background:var(--p-navy);color:#fff;font-family:var(--mono);font-size:8.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:4px 8px;border-radius:0 0 0 7px}.hb-root .hb-pt .hb-obody{border-top:1px solid var(--p-line2);padding:0 14px 13px}.hb-root .hb-pt .hb-plus{display:grid;place-items:center;height:16px;color:var(--p-faint);font-size:13px;font-weight:700}.hb-root .hb-pt .hb-added{display:flex;gap:9px;align-items:center;background:#EAF7F0;color:#136C4C;border-radius:9px;padding:10px 12px;font-size:11.5px;margin:0 0 10px;font-weight:600}.hb-root .hb-kf{border:1px solid var(--p-line);border-radius:12px;overflow:hidden;background:#fff}.hb-root .hb-kf-top{display:flex;align-items:center;gap:9px;padding:9px 12px;border-bottom:1px solid var(--p-line2);background:#FAFBFD}.hb-root .hb-kf-selo{font-family:var(--mono);font-size:9px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;background:var(--p-navy);color:#fff;padding:4px 8px;border-radius:5px}.hb-root .hb-kf-selo.hb-solo{background:var(--p-grey);color:var(--p-mute)}.hb-root .hb-kf-tam{font-size:11px;color:var(--p-mute);margin-left:auto}.hb-root .hb-kf-tam b{color:var(--p-ink2);font-weight:600}.hb-root .hb-kf-grid{display:flex;align-items:stretch;gap:0;padding:12px;background:#fff}.hb-root .hb-kf-cell{flex:1 1 0;min-width:0;margin:0;display:flex;flex-direction:column;gap:7px}.hb-root .hb-kf-img{display:block;width:100%;aspect-ratio:1/1;border-radius:9px;border:1px solid var(--p-line2);background-size:cover;background-position:center;background-color:#F7F9FC}.hb-root .hb-kf-cell figcaption{font-size:11px;line-height:1.3;color:var(--p-mute);text-align:center}.hb-root .hb-kf-cell figcaption b{display:block;font-size:11.5px;font-weight:700;color:var(--p-ink)}.hb-root .hb-kf-plus{flex:0 0 26px;display:grid;place-items:center;color:var(--p-faint);font-size:15px;font-weight:700;align-self:center;padding-bottom:22px}.hb-root .hb-kf[data-n=\"4\"] .hb-kf-grid{flex-wrap:wrap}.hb-root .hb-kf[data-n=\"4\"] .hb-kf-cell{flex:1 1 42%}.hb-root .hb-kf[data-n=\"4\"] .hb-kf-plus{flex:0 0 22px}.hb-root .hb-kf-out{background:#FAFBFD;border-top:1px solid var(--p-line2);padding:9px 12px;font-size:11px;color:var(--p-mute);display:flex;gap:8px;align-items:center;flex-wrap:wrap}.hb-root .hb-kf-out b{color:var(--p-ink2);font-weight:600}.hb-root .hb-kf-falta{background:var(--p-warn);color:var(--p-warn-ink)}.hb-root .hb-kf-foto{display:block;width:100%;aspect-ratio:1/1;border-radius:12px;border:1px solid var(--p-line);background-size:cover;background-position:center}.hb-root .hb-pt code{font-family:var(--mono);font-size:.86em;background:var(--p-grey);padding:2px 5px;border-radius:4px;color:var(--p-mute)}.hb-root .hb-pt .hb-ohead{display:flex;align-items:center;gap:10px;padding:13px 14px}.hb-root .hb-pt .hb-cta[data-off=\"1\"]{opacity:.45;cursor:not-allowed}.hb-root .hb-pt .hb-selcolor{position:relative;flex:1 1 0;min-width:0}.hb-root .hb-pt .hb-selcolor .hb-dotsel{position:absolute;left:9px;top:50%;transform:translateY(-50%);width:12px;height:12px;border-radius:50%;border:1px solid rgba(29,36,48,.18);background-size:cover;background-position:center;pointer-events:none}.hb-root .hb-pt .hb-selcolor select{padding-left:27px}.hb-root .hb-pt .hb-selwrap select{flex:1 1 0}.hb-root .hb-pt .hb-ditem{display:flex;gap:11px;align-items:flex-start;padding:10px 0}.hb-root .hb-pt .hb-ditem .hb-grow{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}.hb-root .hb-pt .hb-dnome{font-size:12.5px;font-weight:700;color:var(--p-ink)}.hb-root .hb-pt .hb-dsub{font-size:10.5px;color:var(--p-faint)}.hb-root .hb-pt .hb-ditem .hb-selwrap{margin-top:5px}.hb-root .hb-pt .hb-dadd{margin-top:8px}.hb-root .hb-pt .hb-offpct{font-family:var(--mono);font-size:9px;font-weight:700;letter-spacing:.06em;background:var(--p-navy);color:#fff;padding:3px 6px;border-radius:5px}.hb-root .hb-pt .hb-offer .hb-offpct{position:absolute;top:26px;right:10px;z-index:2;margin:0}.hb-root .hb-pt .hb-offer[data-sel=\"0\"] .hb-offpct{display:none}.hb-root .hb-pt{--p-off:#12805C}.hb-root .hb-pt .hb-offpct{background:var(--p-off)}.hb-root .hb-pt .hb-offer[data-sel=\"0\"] .hb-offpct{display:block}.hb-root .hb-pt .hb-op .hb-un{font-size:11px;font-weight:600;opacity:.7;margin-left:1px}.hb-root .hb-pt .hb-op .hb-opsub{display:block;font-size:9.5px;color:var(--p-faint);margin-top:2px}.hb-root .hb-pt .hb-del{width:26px;height:26px;border-radius:7px;color:var(--p-faint);font-size:18px;line-height:1;display:grid;place-items:center;flex:0 0 auto}.hb-root .hb-pt .hb-del:hover{background:#F1F4F9;color:var(--p-ink)}@container (max-width:480px){.hb-root .hb-pt-pad{padding:16px}.hb-root .hb-pt h2{font-size:18px}.hb-root .hb-kf,.hb-root .hb-kf-foto{border-radius:0;border-left:0;border-right:0}.hb-root .hb-kf-grid{padding:10px}.hb-root .hb-pt .hb-ditem .hb-selwrap{flex-direction:column}.hb-root .hb-pt .hb-flag{position:static;display:block;text-align:right;border-radius:0;padding:5px 10px}.hb-root .hb-pt .hb-offer .hb-ohead{flex-wrap:wrap;padding-bottom:11px}.hb-root .hb-pt .hb-offer .hb-on{flex:1 1 auto;min-width:0}.hb-root .hb-pt .hb-offer .hb-on small{margin-left:0;display:inline-block;margin-top:5px}.hb-root .hb-pt .hb-offer .hb-op{flex:1 1 100%;margin:9px 0 0 27px;text-align:left;display:flex;align-items:baseline;gap:9px}.hb-root .hb-pt .hb-offer .hb-offpct{position:static;display:inline-block;margin-right:0}.hb-root .hb-pt .hb-offer .hb-op .hb-money{display:inline}}@media (prefers-reduced-motion:reduce){.hb-root .hb-pt *{transition:none !important}}.hb-root{--p-ink:#1D2430;--p-ink2:#333C5E;--p-mute:#4D5878;--p-faint:#8892A8;--p-line:#E4E9F1;--p-line2:#EFF2F7;--p-grey:#F2F2F2;--p-tint:#E9F4FE;--p-warn:#FBF4E1;--p-warn-ink:#7A5A12;--p-navy:#333C5E;--p-blue:#0094FF;--p-blue-ink:#FFFFFF;--sans:\"Poppins\",system-ui,-apple-system,\"Segoe UI\",sans-serif;--mono:ui-monospace,SFMono-Regular,\"SF Mono\",Menlo,monospace;container-type:inline-size;font-family:var(--sans);color:var(--p-ink);text-align:left}.hb-root *{box-sizing:border-box}#hb-app{margin:4px 0 0}#hb-gal{margin:0 0 12px}.hb-root .hb-pt{overflow:visible}.hb-root .hb-pt .hb-sticky{position:sticky;bottom:0;z-index:3;box-shadow:0 -6px 18px -12px rgba(29,36,48,.35)}.hb-root .hb-kf-foto{display:block;width:100%;aspect-ratio:1/1;border-radius:12px;border:1px solid var(--p-line);background-size:cover;background-position:center;background-color:#F7F9FC}.hb-root .hb-thumbs{display:flex;gap:8px;margin:10px 0 0;overflow-x:auto;padding-bottom:2px}.hb-root .hb-thumbs button{flex:0 0 auto;width:58px;height:58px;border-radius:9px;border:1px solid var(--p-line);background-size:cover;background-position:center;position:relative;overflow:hidden;background-color:#fff;padding:0;cursor:pointer}.hb-root .hb-thumbs button[aria-pressed=\"true\"]{border-color:var(--p-blue);box-shadow:0 0 0 2px var(--p-tint)}.hb-root .hb-thumbs .hb-tkit{display:grid;place-items:center}.hb-root .hb-thumbs .hb-tkit i{position:absolute;inset:0;display:flex}.hb-root .hb-thumbs .hb-tkit i b{flex:1 1 0;background-size:cover;background-position:center;display:block}.hb-root .hb-thumbs .hb-tkit em{position:absolute;left:0;right:0;bottom:0;background:var(--p-navy);color:#fff;font-style:normal;font-family:var(--mono);font-size:7px;font-weight:700;letter-spacing:.06em;text-align:center}.hb-root .hb-pt .hb-offer.hb-ofertakc .hb-ohead{padding-top:50px}@container (max-width:480px){.hb-root .hb-pt .hb-offer.hb-ofertakc .hb-ohead{padding-top:54px}}.hb-root .hb-pt .hb-stepcard + .hb-stepcard{margin-top:10px}.hb-root .hb-pt .hb-stephead{display:block;width:100%;text-align:center;cursor:pointer}.hb-root .hb-pt .hb-stephead:hover{background:#EEF2F8}.hb-root .hb-pt .hb-chev{position:absolute;right:12px;top:50%;transform:translateY(-40%);font-size:14px;line-height:1;color:var(--p-faint)}.hb-root .hb-pt .hb-stepsum{display:flex;align-items:center;gap:11px;width:100%;padding:10px 14px;background:#fff;text-align:left}.hb-root .hb-pt .hb-stepsum:hover{background:#F7F9FC}.hb-root .hb-pt .hb-stepsum .hb-grow{flex:1 1 auto;min-width:0}.hb-root .hb-pt .hb-stepsum .hb-mnome{display:block}.hb-root .hb-pt .hb-stepsum .hb-ip{text-align:right;flex:0 0 auto}.hb-root .hb-pt .hb-stepsum .hb-ip .hb-old{display:block;font-size:10.5px}.hb-root .hb-pt .hb-stepsum .hb-ip .hb-money{font-size:13.5px}.hb-root .hb-pt .hb-stepsum .hb-edit{flex:0 0 auto}.hb-root .hb-pt .hb-stepcard.hb-fora{border-color:#E8C97A}.hb-root .hb-pt .hb-stepsum .hb-msel b{color:var(--p-warn-ink);font-weight:700}@container (max-width:480px){.hb-root .hb-pt .hb-stepsum{flex-wrap:wrap;gap:8px 11px}.hb-root .hb-pt .hb-stepsum .hb-ip{order:3;margin-left:53px;text-align:left}.hb-root .hb-pt .hb-stepsum .hb-ip .hb-old{display:inline;margin-right:6px}.hb-root .hb-pt .hb-stepsum .hb-edit{order:4;margin-left:auto}}.hb-root .hb-pt .hb-dpct{position:absolute;top:-8px;right:-6px;background:var(--p-off);color:#fff;font-size:8px;font-weight:800;letter-spacing:.04em;padding:2px 5px;border-radius:5px;white-space:nowrap;line-height:1.3}.hb-root .hb-pt .hb-dcheck{right:auto;left:-7px}.hb-root .hb-pt .hb-item .hb-ip .hb-old{display:inline-block}.hb-root .hb-pt .hb-rowoff{display:inline-block;font-size:9.5px;font-weight:800;background:var(--p-off);color:#fff;padding:2px 6px;border-radius:5px;margin-left:6px;vertical-align:middle;letter-spacing:.02em;line-height:1.3}.hb-root .hb-pt .hb-item .hb-ip .hb-money{display:block}.hb-root .hb-pt .hb-sticky.hb-sticky-cta .hb-cta{width:100%;flex:1 1 auto}.hb-root .hb-pt .hb-dh3.hb-dh3-topo{margin-top:0}.hb-root .hb-pt .hb-offer.hb-offer-topo{margin-top:0}.hb-root .hb-topo{margin:0 0 18px;font-size:16px;line-height:1.4;color:#333C5E}.hb-root .hb-topo .hb-toplbl{display:flex;align-items:baseline;justify-content:space-between;gap:12px;font-size:16px;font-weight:500;line-height:1.4;color:#333C5E;margin:0 0 8px;min-height:auto;column-gap:normal}.hb-root .hb-topo .hb-toplbl>:last-child{margin-left:12px}.hb-root .hb-topo .hb-toplbl b{font-weight:400;color:#666}.hb-root .hb-topo .hb-kflag{font-size:10px;font-weight:600;color:var(--p-faint);background:var(--p-line2);border:1px solid var(--p-line);padding:2px 7px;border-radius:5px;white-space:nowrap;line-height:1.4}.hb-root .hb-topo .hb-medidas{font-size:12px;font-weight:600;color:#000;text-decoration:underline;cursor:pointer;line-height:1.4;white-space:nowrap}.hb-root .hb-topo .hb-topsws{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 20px;padding:0;min-height:auto}.hb-root .hb-topo .hb-topsws.hb-comnovo{row-gap:19px;margin-top:11px}.hb-root .hb-topo .hb-swt{position:relative;display:block;width:30px;height:30px;padding:0;border:0;border-radius:6px;background:#fff;cursor:pointer;line-height:1.4;font-size:16px;color:#333C5E;box-sizing:border-box;text-align:center}.hb-root .hb-topo .hb-swt[aria-pressed=\"true\"]{background:#333C5E;color:#fff;border-color:#333C5E;outline:1px solid #333C5E;overflow:visible}.hb-root .hb-topo .hb-swt:hover:not([disabled]){outline:1px solid rgba(51,60,94,.45)}.hb-root .hb-topo .hb-swt[disabled]{cursor:not-allowed}.hb-root .hb-topo .hb-swt[data-esg] .hb-swtq{opacity:.55}.hb-root .hb-topo .hb-chipt[data-esg]{opacity:.55;text-decoration:line-through}.hb-root .hb-topo .hb-chipt[data-esg][aria-pressed=\"true\"]{opacity:1}.hb-root.hb-esgotado .hb-offer,.hb-root.hb-esgotado .hb-cta,.hb-root.hb-esgotado .hb-sticky{display:none!important}.hb-root .hb-topo .hb-swtq{display:block;width:30px;height:30px;box-sizing:border-box;border:1px solid rgba(51,60,94,.1);border-color:color(srgb 0.2 0.235294 0.368627 / 0.1);border-radius:2px;background:var(--swatch-background,#ddd);background-size:30px 30px;background-position:50% 50%;position:relative;overflow:hidden}.hb-root .hb-topo .hb-swt[disabled] .hb-swtq{opacity:.55}.hb-root .hb-topo .hb-swt .hb-risco{position:absolute;inset:0;pointer-events:none;background:linear-gradient(to top left,transparent calc(50% - .5px),rgba(51,60,94,.55) 50%,transparent calc(50% + .5px))}.hb-root .hb-topo .hb-swnovo{position:absolute;top:-11px;left:0;right:0;width:100%;box-sizing:border-box;text-align:center;z-index:5;background:#333C5E;color:#fff;font-size:8px;font-weight:700;letter-spacing:.05em;line-height:1;padding:2px 0;border-radius:2px;pointer-events:none;white-space:nowrap}.hb-root .hb-topo .hb-topchips{display:flex;flex-wrap:wrap;gap:8px;margin:0;min-height:auto}.hb-root .hb-topo .hb-chipt{display:flex;align-items:center;justify-content:center;min-height:calc(3ch + 1.3em);padding:11.2px 16px;border:1px solid #333C5E;border-radius:6px;background:#fff;color:#333C5E;font-family:var(--sans);font-size:16px;font-weight:400;line-height:1.4;white-space:nowrap;cursor:pointer;box-sizing:border-box;text-align:center;transition:background-color .15s ease,color .15s ease}.hb-root .hb-topo .hb-chipt[aria-pressed=\"true\"]{background:#333C5E;border-color:#333C5E;color:#fff}.hb-root .hb-topo .hb-chipt:hover:not([disabled]):not([aria-pressed=\"true\"]){background:rgba(51,60,94,.06)}.hb-root .hb-topo .hb-chipt[disabled]{opacity:.55;cursor:not-allowed;text-decoration:line-through}@media screen and (min-width:750px){.hb-root .hb-topo .hb-chipt{padding:8px 12.8px}}.hb-root .hb-pt .hb-cheio{display:block;font-size:12px;font-weight:500;color:#8a8f98;text-decoration:line-through;line-height:1.1;margin-bottom:2px;font-variant-numeric:tabular-nums}.hb-root .hb-pt .hb-ap .hb-cheio{display:inline;margin:0 6px 0 0;font-size:11px}@container (max-width:480px){.hb-root .hb-pt .hb-offer .hb-op{flex-wrap:wrap}.hb-root .hb-pt .hb-offer .hb-op .hb-cheio{flex:1 1 100%;margin-bottom:0}}";
var PCT_KIT = 20, PCT_PIX = 0, MIN_KIT = 2;
function aplicaPix() {
var d = (typeof document !== 'undefined') ? document.documentElement : null;
var seco = !!((d && d.classList && d.classList.contains('t1-20')) ||
(typeof window !== 'undefined' && typeof window.__t1 === 'function'));
PCT_PIX = seco ? 0 : 2;
return PCT_PIX;
}
var FAIXAS = {
'9636591075563': { h: 'roupao-hoomy', pct: 20, min: 2 },
'8151677337835': { h: 'jogo-de-lencol-hoomy', pct: 20, min: 2 },
'8168144503019': { h: 'toalha-hoomy-1x', pct: 20, min: 2 },
'8764603826411': { h: 'travesseiro-hoomy-1', pct: 20, min: 2 },
'9199864742123': { h: 'travesseiro-comfort', pct: 20, min: 2 },
'9130685759723': { h: 'jogo-de-toalha-light-100-algodao-turco', pct: 20, min: 2 },
'9115393589483': { h: 'edredom-hoomy', pct: 20, min: 2 },
'8971664163051': { h: 'jogo-de-toalha-hoomy-mtrc-2', pct: 27, min: 2 },
'9898514383083': { h: 'jogo-de-toalha-100-algodao-turco', pct: 14, min: 2 },
'8943374434539': { h: 'tapete-turco-hoomy', pct: 20, min: 2 },
'8921750175979': { h: 'pijama-hoomy-1', pct: 20, min: 2 },
'8807585284331': { h: 'capa-de-edredom-hoomy', pct: 20, min: 2 },
'8245047623915': { h: 'lencol-hoomy-unidade', pct: 20, min: 2 },
'10310736281835': { h: 'pillowtop-hoomy', pct: 20, min: 2 },
'9903105671403': { h: 'lencol', pct: 20, min: 2 },
'9372951871723': { h: 'weighted-blanket', pct: 20, min: 2 },
'9481057075435': { h: 'travesseiro-comfort-hoomy-produto-virtual', pct: 25, min: 2 }
};
function aplicaFaixa(pid) {
var f = FAIXAS[String(pid)];
if (!f || typeof f.pct !== 'number' || f.pct <= 0 || !(f.min >= 1)) return false;
PCT_KIT = f.pct; MIN_KIT = f.min;
return true;
}
function idPorHandle(h) {
for (var k in FAIXAS) {
if (Object.prototype.hasOwnProperty.call(FAIXAS, k) && FAIXAS[k].h === h) return k;
}
return null;
}
var fl = function (n) { return Math.floor(n + 1e-6); };
var aloc = function (unC, pct) { return fl(unC * pct / 100); };
var unCartao = function (unC, pct) { return unC - aloc(unC, pct); };
var unPix = function (unC, pct) { return Math.round(unCartao(unC, pct) * (100 - PCT_PIX) / 100); };
var pixDoTotal = function (cartC) { return Math.round(cartC * (100 - PCT_PIX) / 100); };
var pctPara = function (nUn) { return nUn >= MIN_KIT ? PCT_KIT : 0; };
var pctAte = function (pct) {
if (pct == null) pct = PCT_KIT;
return Math.round((1 - (100 - pct) * (100 - PCT_PIX) / 10000) * 100);
};
/* 28/10 (Thiago, pedido do CEO): preco cheio riscado acima do preco com desconto nas 3 linhas de oferta.
   Classe bf26-cheio junto: o teste "Valor x %" da V3 (snippets/bf26-teste-variantes) reaproveita o elemento em vez de criar outro. */
var riscado = function (cheio, por) { return cheio > por ? '<s class="hb-cheio bf26-cheio">' + fmt(cheio) + '</s>' : ''; };
var noPix = function () { return PCT_PIX ? ' <small class="hb-un">no Pix</small>' : ''; };
var fmt = function (c) {
return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
function autoTeste() {
var q = unPix(98290, 20), k = unPix(105290, 20), f = unPix(23000, 20);
var casos;
if (PCT_PIX === 2) {
casos = [
['unidade Queen no kit (Pix)', q, 77059],
['unidade King no kit (Pix)', k, 82547],
['unidade Queen avulsa (so Pix)', unPix(98290, 0), 96324],
['kit fronha dentro do kit (Pix)', f, 18032],
['travesseiro dentro do kit (Pix)', unPix(41790, 20), 32763],
['total 2 jogos (Queen + King)', q + k, 159606],
['total 2 jogos + kit fronha', q + k + f, 177638],
['economia com kit fronha', (98290 + 105290 + 23000) - (q + k + f), 48942],
['parcela 3x sem fronha', fl((unCartao(98290, 20) + unCartao(105290, 20)) / 3), 54288],
['parcela 3x com fronha', fl((unCartao(98290, 20) + unCartao(105290, 20) + unCartao(23000, 20)) / 3), 60421]
];
casos.push(['total no Pix do carrinho de 2 Queen', pixDoTotal(157264), 154119]);
casos.push(['parcela 3x do carrinho de 2 Queen', fl(157264 / 3), 52421]);
casos.push(['selo "N% OFF" (kit + Pix, arredondado)', pctAte(), 22]);
casos.push(['selo com 20 de kit', pctAte(20), 22]);
casos.push(['selo com 30 de kit', pctAte(30), 31]);
casos.push(['selo sem kit e so o Pix', pctAte(0), 2]);
casos.push(['Pillow Top Queen + lencol Google Queen no Pix',
pixDoTotal(unCartao(182790, 20) + unCartao(83546, 20)), 208808]);
} else if (PCT_PIX === 0) {
casos = [
['unidade Queen no kit', q, 78632],
['unidade King no kit', k, 84232],
['unidade Queen avulsa (sem kit)', unPix(98290, 0), 98290],
['kit fronha dentro do kit', f, 18400],
['travesseiro dentro do kit', unPix(41790, 20), 33432],
['total 2 jogos (Queen + King)', q + k, 162864],
['total 2 jogos + kit fronha', q + k + f, 181264],
['economia com kit fronha', (98290 + 105290 + 23000) - (q + k + f), 45316],
['parcela 3x sem fronha', fl((unCartao(98290, 20) + unCartao(105290, 20)) / 3), 54288],
['parcela 3x com fronha', fl((unCartao(98290, 20) + unCartao(105290, 20) + unCartao(23000, 20)) / 3), 60421]
];
casos.push(['total do carrinho de 2 Queen', pixDoTotal(157264), 157264]);
casos.push(['parcela 3x do carrinho de 2 Queen', fl(157264 / 3), 52421]);
casos.push(['selo "N% OFF" (a faixa seca, sem Pix)', pctAte(), 20]);
casos.push(['selo com 20 de kit', pctAte(20), 20]);
casos.push(['selo com 30 de kit', pctAte(30), 30]);
casos.push(['selo sem kit e zero', pctAte(0), 0]);
} else {
casos = [['PCT_PIX medido (0 ou 2)', PCT_PIX, 'medido']];
}
var medidos = { 14: 1, 20: 1, 25: 1, 27: 1, 30: 1 }, ruins = 0, nFaixas = 0;
for (var h in FAIXAS) {
if (!Object.prototype.hasOwnProperty.call(FAIXAS, h)) continue;
nFaixas++;
if (!medidos[FAIXAS[h].pct] || !(FAIXAS[h].min >= 1) || !FAIXAS[h].h) ruins++;
}
casos.push(['tabela de faixas nao esta vazia', nFaixas > 0, true]);
casos.push(['toda faixa da tabela foi medida na loja', ruins, 0]);
var falhas = casos.filter(function (c) { return c[1] !== c[2]; });
return {
ok: falhas.length === 0,
n: casos.length - falhas.length,
total: casos.length,
casos: casos,
falhas: falhas.map(function (c) { return c[0] + ': ' + c[1] + ' != ' + c[2]; })
};
}
var HEX = {
'White': '#fafafa', 'Light Gray': '#cdcfd0', 'Azul Hoomy': '#040548',
'Cloud Dancer': '#F2F1ED', 'Light Green': '#75806b', 'Celestial Blue': '#b4c9f1',
'Light Rose': '#e0c7bf', 'Mocha Mousse': '#9a5630', 'Mocha': '#9a5630', 'Rose': '#d9a7a1',
'New York': null, 'Green': '#3d5c47', 'Graphite': '#4a4a4a', 'Beige': '#d8c9b0',
'Ocean Blue': '#2c5f83'
};
function comLargura(src, w) {
if (!src) return '';
return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}
function catalogo(json, iCor, iTam, iMod) {
var TAM_UNICO = 'Único';
var opt = function (i) { return (json.options && json.options[i]) || {}; };
var nomeOpt = function (i, padrao) { var n = opt(i); n = (typeof n === 'string') ? n : n.name; return n || padrao; };
var valsCor = (iCor == null) ? ['Default Title'] : (opt(iCor).values || []);
var ordemCor = (iMod == null) ? valsCor
: [].concat.apply([], (opt(iMod).values || []).map(function (m) {
return valsCor.map(function (c) { return m + ' · ' + c; });
}));
var ordemTam = (iTam == null) ? [TAM_UNICO] : (opt(iTam).values || []);
var crua = function (v, i) { return i === 0 ? v.option1 : (i === 1 ? v.option2 : v.option3); };
var chave = function (v, i) {
if (i == null) return 'Default Title';
if (i === iCor && iMod != null) return crua(v, iMod) + ' · ' + crua(v, iCor);
return crua(v, i);
};
var cores = ordemCor.map(function (nome) {
return {
nome: nome, hex: (nome in HEX) ? HEX[nome] : null,
disp: {}, vid: {}, sku: {}, preco: {}, foto: '', swatch: ''
};
});
var porNome = {};
cores.forEach(function (c) { porNome[c.nome] = c; });
(json.variants || []).forEach(function (v) {
var cn = chave(v, iCor), tn = (iTam == null) ? TAM_UNICO : chave(v, iTam);
var c = porNome[cn];
if (!c) { c = { nome: cn, hex: (cn in HEX) ? HEX[cn] : null, disp: {}, vid: {}, sku: {}, preco: {}, foto: '', swatch: '' }; porNome[cn] = c; cores.push(c); }
c.disp[tn] = !!v.available || c.disp[tn] === true;
c.vid[tn] = v.id;
c.sku[tn] = v.sku || '';
c.preco[tn] = v.price;
var f = v.featured_image && v.featured_image.src;
if (f && !c.foto) { c.foto = comLargura(f, 400); c.swatch = comLargura(f, 80); }
});
var tamanhos = ordemTam.map(function (nome) {
var pr = null;
for (var i = 0; i < cores.length; i++) {
var p = cores[i].preco[nome];
if (p != null && (pr == null || cores[i].disp[nome])) { pr = p; if (cores[i].disp[nome]) break; }
}
return { nome: nome, precoC: pr };
}).filter(function (t) { return t.precoC != null; });
var fotoPadrao = (json.featured_image && (json.featured_image.src || json.featured_image)) ||
(json.images && json.images[0]) || '';
if (fotoPadrao) {
for (var fi = 0; fi < cores.length; fi++) {
if (!cores[fi].foto) {
cores[fi].foto = comLargura(fotoPadrao, 400);
cores[fi].swatch = comLargura(fotoPadrao, 80);
}
}
}
var ocultas = (window.__hbCoresOcultas && window.__hbCoresOcultas[json.handle]) || []; /* 20/10/2026: snippet cor-oculta */
var coresVivas = cores.filter(function (c) { return Object.keys(c.vid).length > 0 && ocultas.indexOf(c.nome) < 0; });
var corUnica = coresVivas.length === 1 &&
(coresVivas[0].nome === 'Default Title' || coresVivas[0].nome === TAM_UNICO);
return {
handle: json.handle, titulo: json.title, pid: json.id,
temTamanho: iTam != null, tamUnico: TAM_UNICO, corUnica: corUnica,
rotCor: (iMod != null) ? 'Modelo e cor' : (iCor == null ? 'Cor' : nomeOpt(iCor, 'Cor')),
rotTam: (iTam == null) ? 'Tamanho' : nomeOpt(iTam, 'Tamanho'),
cores: coresVivas,
tamanhos: tamanhos
};
}
function descobreOpcoes(json) {
var nomes = ((json && json.options) || []).map(function (o) {
var n = (typeof o === 'string' ? o : (o && o.name) || '');
return n.toLowerCase()
.replace(new RegExp('[à-å]', 'g'), 'a').replace(new RegExp('[è-ë]', 'g'), 'e')
.replace(new RegExp('[ì-ï]', 'g'), 'i').replace(new RegExp('[ò-ö]', 'g'), 'o')
.replace(new RegExp('[ù-ü]', 'g'), 'u').replace(new RegExp('[ç]', 'g'), 'c')
.trim();
});
var ehCor = function (n) { return n.indexOf('cor') === 0 || n === 'color' || n === 'title'; };
var ehTam = function (n) { return n.indexOf('tamanho') === 0 || n === 'size' || n.indexOf('medida') === 0 || n === 'peso'; };
var ehMod = function (n) { return n === 'modelo'; };
var iCor = -1, iTam = -1, iMod = -1, estranhas = 0;
for (var i = 0; i < nomes.length; i++) {
if (iCor < 0 && ehCor(nomes[i])) iCor = i;
else if (iTam < 0 && ehTam(nomes[i])) iTam = i;
else if (iMod < 0 && ehMod(nomes[i])) iMod = i;
else estranhas++;
}
if (iMod >= 0 && iCor >= 0 && iTam >= 0 && estranhas === 0 && nomes.length === 3) {
return { iCor: iCor, iTam: iTam, iMod: iMod, ok: true };
}
if (iMod >= 0) estranhas++;
if (iCor < 0 && iTam >= 0 && estranhas === 0 && nomes.length === 1) {
return { iCor: null, iTam: iTam, ok: true };
}
if (iCor < 0 || estranhas > 0 || nomes.length === 0 || nomes.length > 2) {
return { iCor: iCor < 0 ? 0 : iCor, iTam: iTam < 0 ? (nomes.length > 1 ? 1 : null) : iTam, ok: false };
}
return { iCor: iCor, iTam: iTam < 0 ? null : iTam, ok: true };
}
var CAT = null;                       // preenchido por catalogo() no boot
var ORD = ['1ª', '2ª', '3ª', '4ª', '5ª', '6ª', '7ª', '8ª'];
var ordPt = function (i) { return (i + 1) + 'º'; };
var ordFem = function (i) { return ORD[i] || (i + 1) + 'ª'; };
var COMP = null;
var catK = function (k) { return (k && typeof CATS !== 'undefined' && CATS[k]) || CAT; };
var corPor = function (n, k) { var K = catK(k); for (var i = 0; i < K.cores.length; i++) if (K.cores[i].nome === n) return K.cores[i]; return null; };
var tamPor = function (n, k) { var K = catK(k); for (var i = 0; i < K.tamanhos.length; i++) if (K.tamanhos[i].nome === n) return K.tamanhos[i]; return null; };
var precoTam = function (t, k) { var x = tamPor(t, k); return x ? x.precoC : 0; };
var precoDe = function (cor, tam, k) { var c = corPor(cor, k); var p = c && c.preco[tam]; return p != null ? p : precoTam(tam, k); };
var disp = function (cor, tam, k) { var c = corPor(cor, k); return !c ? false : !!c.disp[tam]; };
var vidDe = function (cor, tam, k) { var c = corPor(cor, k); return c ? c.vid[tam] : null; };
var pronta = function (m) { return !!m.cor && disp(m.cor, m.tam, m.p); };
var swBg = function (nome, k) {
var c = corPor(nome, k); if (!c) return 'background:#ddd';
return c.hex ? 'background:' + c.hex : 'background-image:url(' + (c.swatch || c.foto) + ')';
};
var fotoBg = function (nome, k) {
var c = corPor(nome, k); if (!c) return 'background:#eee';
return c.foto ? 'background-image:url(' + c.foto + ')' : swBg(nome, k);
};
var lum = function (hex) {
var c = hex.replace('#', ''); var v = function (i) { return parseInt(c.substr(i, 2), 16) / 255; };
return 0.2126 * v(0) + 0.7152 * v(2) + 0.0722 * v(4);
};
var dotCor = function (nome, k) { var c = corPor(nome, k); return (!c || !c.hex || lum(c.hex) > 0.6) ? '#1D2430' : '#FFFFFF'; };
function novaMuda(tam, k) {
var K = catK(k), c = null;
if (!tamPor(tam, k) && K.tamanhos[0]) tam = K.tamanhos[0].nome;   // produto sem esse tamanho
for (var i = 0; i < K.cores.length; i++) if (K.cores[i].disp[tam]) { c = K.cores[i]; break; }
return { cor: (c || K.cores[0]).nome, tam: tam, tamProprio: false, dec: false, p: k || 0 };
}
function mudasBase(t, n) {
if (COMP) return COMP.map(function (k) { return novaMuda(t, k); });
var r = []; for (var i = 0; i < n; i++) r.push(novaMuda(t)); return r;
}
function tamPadrao() {
var alvo = 'Queen';                       // padrão de repouso do protótipo
var todos = COMP ? COMP.every(function (k) { return !!tamPor(alvo, k); }) : !!tamPor(alvo);
return todos ? alvo : (CAT.tamanhos[0] && CAT.tamanhos[0].nome);
}
function segundaCor(tam) {
var alvo = 'Azul Hoomy';                  // 2ª muda do estado de repouso (B e D)
if (disp(alvo, tam)) return alvo;
for (var i = 0; i < CAT.cores.length; i++) if (CAT.cores[i].disp[tam]) return CAT.cores[i].nome;
return null;
}
function novoEstado(braco) {
var t = tamPadrao();
var s = {
braco: braco, degrau: 2, tamKit: t,
mudas: mudasBase(t, 2),
aberto: 0, passo: 0, confirm: null, adicionado: false, erro: null, ocupado: false,
foco: 0,
oferta: 'kit', acc: -1
};
var c2 = COMP ? null : segundaCor(t);
if (c2) s.mudas[1].cor = c2;              // dois jogos iguais lado a lado não mostram o kit
return s;
}
function proxPendente(s, apos) {
var n = s.mudas.length;
for (var k = 1; k <= n; k++) { var j = (((apos == null ? -1 : apos) + k) % n + n) % n; if (!pronta(s.mudas[j])) return j; }
return -1;
}
function decidiu(s, i) {
s.mudas[i].dec = true;
s.aberto = proxNaoDecidido(s, i);
}
function proxNaoDecidido(s, apos) {
var n = s.mudas.length;
for (var k = 1; k <= n; k++) { var j = (((apos == null ? -1 : apos) + k) % n + n) % n; if (!s.mudas[j].dec) return j; }
return -1;
}
function acao(s, act, arg, i) {
i = (i === undefined || i === '') ? null : +i;
if (act !== 'cta' && act !== 'gal') { s.adicionado = false; s.erro = null; }
switch (act) {
case 'degrau': {
var n = +arg, antes = s.mudas.length; s.degrau = n;
if (n > antes) {
if (COMP && antes < COMP.length) s.mudas = s.mudas.concat(mudasBase(s.tamKit).slice(antes, n));
while (s.mudas.length < n) s.mudas.push(novaMuda(s.tamKit));
s.aberto = proxNaoDecidido(s, -1);
}
else if (n < antes) { s.mudas.length = n; if (s.aberto >= n) s.aberto = proxNaoDecidido(s, -1); }
if (n !== antes) s.passo = 0;          // mexer na quantidade recomeça o passo a passo
s.passo = Math.min(s.passo, s.mudas.length - 1);
s.foco = Math.min(s.foco || 0, s.mudas.length - 1);
break;
}
case 'tamKit': {
s.tamKit = arg; s.confirm = null; s.foco = 0;
s.mudas.forEach(function (m) { if (tamPor(arg, m.p)) { m.tam = arg; m.tamProprio = false; } });
break;
}
case 'corKit': {
var ref = s.mudas[s.foco] || s.mudas[0], tamRef = ref.tam, pRef = ref.p || 0;
s.foco = 0;
s.mudas.forEach(function (m) {
if ((m.p || 0) !== pRef || !corPor(arg, m.p)) return;
m.cor = arg;
if (!disp(m.cor, m.tam, m.p) && disp(m.cor, tamRef, m.p)) { m.tam = tamRef; m.tamProprio = false; }
if (pronta(m)) m.dec = true;        // no C, escolher a cor do kit decide todos os cartões
});
if (s.braco === 'C') s.aberto = proxNaoDecidido(s, -1);
break;
}
case 'conf-todas': s.tamKit = s.confirm; s.mudas.forEach(function (m) { if (tamPor(s.tamKit, m.p)) { m.tam = s.tamKit; m.tamProprio = false; } }); s.confirm = null; break;
case 'conf-manter': s.tamKit = s.confirm; s.mudas.forEach(function (m) { if (!m.tamProprio && tamPor(s.tamKit, m.p)) m.tam = s.tamKit; }); s.confirm = null; break;
case 'cor': { var m = s.mudas[i]; m.cor = arg; s.foco = i; if (pronta(m)) decidiu(s, i); break; }
case 'corSel': s.mudas[i].cor = arg; s.foco = i; break;
case 'tamMuda': {
var mm = s.mudas[i]; mm.tam = arg; s.foco = i;
if (s.braco === 'C' && i === 0) {
s.tamKit = arg; mm.tamProprio = false;
s.mudas.forEach(function (x, ix) { if (ix > 0 && !x.tamProprio && tamPor(arg, x.p)) x.tam = arg; });
} else { mm.tamProprio = (arg !== s.tamKit); }
break;
}
case 'tamSel': s.mudas[i].tam = arg; s.mudas[i].tamProprio = (arg !== s.tamKit); s.foco = i; break;
case 'editar': s.aberto = (s.aberto === i ? -1 : i); if (s.aberto === i) s.foco = i; break;
case 'addItem': case 'addJogo': s.mudas.push(novaMuda(s.tamKit)); s.degrau = s.mudas.length; s.aberto = proxNaoDecidido(s, -1); break;
case 'delItem': {
if (s.mudas.length <= 1) break;
s.mudas.splice(i, 1); s.degrau = s.mudas.length; s.foco = 0;
if (s.passo >= s.mudas.length) s.passo = s.mudas.length - 1;
break;
}
case 'tiraJogo': { if (s.mudas.length <= 2) break; s.mudas.splice(i, 1); s.degrau = s.mudas.length; s.foco = 0; break; }
case 'oferta': {
s.oferta = arg;
if (arg === 'solo') { s.degrau = 1; s.mudas.length = 1; }
else {
s.degrau = 2;
if (COMP && s.mudas.length < COMP.length) s.mudas = s.mudas.concat(mudasBase(s.tamKit).slice(s.mudas.length));
while (s.mudas.length < 2) s.mudas.push(novaMuda(s.tamKit));
}
s.foco = Math.min(s.foco || 0, s.mudas.length - 1);
break;
}
case 'acc': s.acc = (s.acc === i ? -1 : i); break;
case 'voltar': s.passo = Math.max(0, s.passo - 1); break;
case 'cta': {
if (s.mudas.some(function (x) { return !disp(x.cor, x.tam, x.p); })) break;   // sem estoque: inerte
return 'add';                       // em todo braço o CTA é o add: o C deixou de ser passo a passo (14/09)
}
}
return null;
}
function contas(s) {
var nUn = s.mudas.length;
var pct = pctPara(nUn);
var L = s.mudas.map(function (m) {
var b = precoDe(m.cor, m.tam, m.p);
return { b: b, pix: unPix(b, pct), cart: unCartao(b, pct) };
});
var som = function (f) { return L.reduce(function (t, x) { return t + x[f]; }, 0); };
var kitCheio = som('b'), kitCart = som('cart');
var kitPix = pixDoTotal(kitCart);       // total pela conta da loja, não pela soma dos unitários
var eco = kitCheio - kitPix;
return {
pct: pct, L: L, kitPix: kitPix, kitCheio: kitCheio,
totalPix: kitPix, totalCheio: kitCheio, totalCart: kitCart, eco: eco,
pctEco: kitCheio ? Math.round(eco / kitCheio * 100) : 0, parcela: fl(kitCart / 3)
};
}
function itensDoCarrinho(s) {
return s.mudas.map(function (m) { return { id: vidDe(m.cor, m.tam, m.p), quantity: 1 }; });
}
function precoDegrau(s, d) {
var ks = [];
if (COMP && d >= COMP.length) { ks = COMP.slice(); while (ks.length < d) ks.push(0); }
else for (var i = 0; i < d; i++) ks.push(0);
var pct = pctPara(d), tot = 0;
ks.forEach(function (k) {
var t = s.tamKit;
if (k && !tamPor(t, k) && catK(k).tamanhos[0]) t = catK(k).tamanhos[0].nome;   // item de outro produto sem esse tamanho
tot += unPix(precoTam(t, k), pct);
});
return Math.round(tot / d);
}
if (typeof CFG === 'undefined') var CFG = {};
var UN1 = (CFG.unidade && CFG.unidade[0]) || 'item';
var UNn = (CFG.unidade && CFG.unidade[1]) || 'itens';
function nomeProduto(k) {
if (CFG.nome && !k) return CFG.nome;
var K = (typeof catK === 'function') ? catK(k) : CAT;
var t = (K && K.titulo) || '';
return t.split('|')[0].trim() || 'produto';
}
function composicaoHTML(n) {
var c = CFG.composicao;
if (!c || !c.length) return '';
return c.map(function (it) {
var q = n * (it.q || 1);
return '<b>' + q + ' ' + (q > 1 ? it.p : it.s) + '</b>';
}).join(' · ');
}
function chipsTam(act, i, sel, k) {
var K = catK(k);
if (!K.temTamanho || K.tamanhos.length < 2) return '';
return '<div class="hb-chips">' + K.tamanhos.map(function (t) {
return '<button type="button" class="hb-chip' + (act === 'tamMuda' ? ' hb-sm' : '') + '" data-act="' + act + '"' +
(i == null ? '' : ' data-i="' + i + '"') + ' data-arg="' + t.nome + '" aria-pressed="' + (t.nome === sel) + '">' +
t.nome + '</button>';
}).join('') + '</div>';
}
function swatches(s, i, comDot) {
var m = s.mudas[i], K = catK(m.p);
if (K.corUnica || K.cores.length < 2) return '';
return '<div class="hb-sws">' + K.cores.map(function (c) {
var ok = !!c.disp[m.tam];
return '<button type="button" class="hb-swb" data-act="cor" data-i="' + i + '" data-arg="' + c.nome + '"' +
' aria-pressed="' + (m.cor === c.nome) + '"' + (ok ? '' : ' disabled') +
' title="' + c.nome + (ok ? '' : ' — sem estoque em ' + m.tam) + '">' +
'<span class="hb-sw" style="' + swBg(c.nome, m.p) + '">' +
(comDot ? '<span class="hb-dot" style="background:' + dotCor(c.nome, m.p) + '"></span>' : '') +
'</span></button>';
}).join('') + '</div>';
}
var SWTEMA = {};
var TEM_MEDIDAS = false;
function swVar(nome, k) {
var t = k ? null : SWTEMA[nome];
if (t && t.bg) return t.bg;
var c = corPor(nome, k);
if (!c) return '--swatch-background:#ddd';
return c.hex ? '--swatch-background:' + c.hex
: '--swatch-background:url(' + (c.swatch || c.foto) + ')';
}
function corNova(nome) { var t = SWTEMA[nome]; return !!(t && t.novo); }
function seletorKit(s) {
var i = Math.min(s.foco || 0, s.mudas.length - 1), m = s.mudas[i];
if (!m) return '';
var K = catK(m.p), mesmos = s.mudas.filter(function (x) { return (x.p || 0) === (m.p || 0); });
var uniforme = mesmos.every(function (x) { return x.cor === m.cor && x.tam === m.tam; });
var flag = mesmos.length < 2 ? ''
: '<span class="hb-kflag">' + (uniforme ? 'vale para os ' + mesmos.length + ' ' + UNn
: UNn + ' com escolhas diferentes') + '</span>';
var temNovo = !m.p && K.cores.some(function (c) { return corNova(c.nome); });
var cores = (K.corUnica || K.cores.length < 2) ? '' :
'<div class="hb-toplbl"><span>' + (K.rotCor || 'Cor') + ': <b>' + m.cor + '</b></span>' + flag + '</div>' +
'<div class="hb-topsws' + (temNovo ? ' hb-comnovo' : '') + '">' + K.cores.map(function (c) {
var ok = !!c.disp[m.tam];
return '<button type="button" class="hb-swt" data-act="corKit" data-arg="' + c.nome + '"' +
' aria-pressed="' + (c.nome === m.cor) + '"' + (ok ? '' : ' data-esg="1"') +
' title="' + c.nome + (ok ? '' : ' — sem estoque em ' + m.tam) + '">' +
'<span class="hb-swtq" style="' + swVar(c.nome, m.p) + '">' + (ok ? '' : '<i class="hb-risco"></i>') + '</span>' +
(!m.p && corNova(c.nome) ? '<span class="hb-swnovo">NEW</span>' : '') + '</button>';
}).join('') + '</div>';
var medidas = (typeof TEM_MEDIDAS !== 'undefined' && TEM_MEDIDAS)
? '<a href="#" class="hb-medidas" data-act="medidas">Tabela de Medidas</a>' : '';
var tams = (!K.temTamanho || K.tamanhos.length < 2) ? '' :
'<div class="hb-toplbl"><span>' + (K.rotTam || 'Tamanho') + ': <b>' + m.tam + '</b></span>' + medidas + '</div>' +
'<div class="hb-topchips">' + K.tamanhos.map(function (t) {
var c = corPor(m.cor, m.p), ok = !!(c && c.disp[t.nome]);
return '<button type="button" class="hb-chipt" data-act="tamKit" data-arg="' + t.nome + '"' +
' aria-pressed="' + (t.nome === m.tam) + '"' + (ok ? '' : ' data-esg="1"') + '>' + t.nome + '</button>';
}).join('') + '</div>';
return (cores || tams) ? '<div class="hb-topo">' + cores + tams + '</div>' : '';
}
function confirmStrip(s) {
if (!s.confirm) return '';
var donas = s.mudas.map(function (m, i) {
return (m.tamProprio && m.tam !== s.confirm) ? ordFem(i) + ' muda está em ' + m.tam : null;
}).filter(Boolean);
return '<div class="hb-conf"><p><b>' + donas.join(' · ') + '.</b> Aplicar ' + s.confirm + ' nela também?</p>' +
'<button type="button" class="hb-cbtn" data-act="conf-todas">Aplicar em todas</button>' +
'<button type="button" class="hb-cbtn hb-alt" data-act="conf-manter">Manter como está</button></div>';
}
function faixaEstoque(s) {
var i = -1;
s.mudas.forEach(function (m, k) { if (i < 0 && m.cor && !disp(m.cor, m.tam, m.p)) i = k; });
if (i < 0) return '';
var m = s.mudas[i];
return '<div class="hb-strip hb-strip-warn" style="margin-top:12px"><span>' + m.cor + ' / ' + m.tam +
' está sem estoque — escolha outra cor para esta unidade.</span></div>';
}
function chamadaEscolha(k) {
var r = rotuloOpcoes(k);
return r ? 'escolha ' + r.toLowerCase().replace(', ', ' e ') : 'confirmar';
}
function subtituloEscolha(n) {
if (COMP && n > 1) return 'cada item com a sua escolha · o tamanho do 1º vale para o kit';
var temCor = !CAT.corUnica, temTam = CAT.temTamanho && CAT.tamanhos.length > 1;
if (!temCor && !temTam) return n > 1 ? 'confirme a quantidade do kit' : 'confirme o seu ' + UN1;
if (n > 1) {
if (temCor && temTam) return 'cada ' + UN1 + ' com a sua cor · o tamanho do 1º vale para o kit';
if (temCor) return 'cada ' + UN1 + ' com a sua cor';
return 'o tamanho do 1º vale para o kit';
}
return temCor && temTam ? 'cor e tamanho' : (temCor ? 'cor' : 'tamanho');
}
function rotuloOpcoes(k) {
var K = catK(k), partes = [];
if (!K.corUnica && K.cores.length > 1) partes.push(K.rotCor || 'Cor');
if (K.temTamanho && K.tamanhos.length > 1) partes.push(K.rotTam || 'Tamanho');
return partes.join(', ');
}
function resumoEscolha(cor, tam, k) {
var K = catK(k), partes = [];
if (!K.corUnica && K.cores.length > 1) partes.push(cor);
if (K.temTamanho && K.tamanhos.length > 1) partes.push(tam);
return partes.join(' · ');
}
function selCor(i, cor, tam, k) {
var K = catK(k);
if (K.corUnica || K.cores.length < 2) return '';
return '<span class="hb-selcolor"><i class="hb-dotsel" style="' + swBg(cor, k) + '"></i>' +
'<select data-act="corSel" data-i="' + i + '" aria-label="' + (K.rotCor || 'Cor') + '">' +
K.cores.map(function (c) {
return '<option value="' + c.nome + '"' + (c.nome === cor ? ' selected' : '') +
(c.disp[tam] ? '' : ' disabled') + '>' + c.nome + (c.disp[tam] ? '' : ' — sem estoque') + '</option>';
}).join('') + '</select></span>';
}
function selTam(i, tam, k) {
var K = catK(k);
if (!K.temTamanho || K.tamanhos.length < 2) return '';
return '<select data-act="tamSel" data-i="' + i + '" aria-label="' + (K.rotTam || 'Tamanho') + '">' +
K.tamanhos.map(function (t) {
return '<option value="' + t.nome + '"' + (t.nome === tam ? ' selected' : '') + '>' + t.nome + '</option>';
}).join('') + '</select>';
}
function resumoItens(s) {
var n = s.mudas.length;
return n + ' ' + (n === 1 ? UN1 : UNn);
}
function feito(s, c) {
if (s.erro) return '<div class="hb-strip hb-strip-warn" style="margin:12px 0 0"><span>' + s.erro + '</span></div>';
if (!s.adicionado) return '';
return '<div class="hb-added" style="margin:12px 0 0"><span>✓</span><span>' +
(s.mudas.length > 1 ? 'Kit adicionado' : 'Adicionado') + ' ao carrinho · ' +
s.mudas.map(function (x) { return x.cor + '/' + x.tam; }).join(' + ') + '</span></div>';
}
function pecasDoKit(s) {
var n = (s.braco === 'D' && s.oferta === 'solo') ? 1 : s.mudas.length;
return s.mudas.slice(0, n).map(function (m, i) {
return { cor: m.cor, tam: m.tam, p: m.p, rot: COMP ? nomeProduto(m.p) : ordPt(i) + ' ' + UN1 };
});
}
function kitViz(s) {
var pc = pecasDoKit(s), n = pc.length, kit = n > 1;
var tams = [], semEst = [];
pc.forEach(function (p) {
if (tams.indexOf(p.tam) < 0) tams.push(p.tam);
if (!disp(p.cor, p.tam, p.p)) semEst.push(p);
});
var celulas = pc.map(function (p, i) {
var c = corPor(p.cor, p.p), fora = !disp(p.cor, p.tam, p.p);
return (i > 0 ? '<span class="hb-kf-plus" aria-hidden="true">+</span>' : '') +
'<figure class="hb-kf-cell">' +
'<span class="hb-kf-img" style="' + fotoBg(p.cor, p.p) + '"></span>' +
'<figcaption><b>' + (kit ? p.rot : nomeProduto()) + '</b>' +
p.cor + ' · ' + p.tam + (fora ? ' · sem estoque' : '') + '</figcaption></figure>';
}).join('');
return '<div class="hb-kf" data-n="' + n + '">' +
'<div class="hb-kf-top">' +
'<span class="hb-kf-selo' + (kit ? '' : ' hb-solo') + '">' +
(kit ? 'SEU KIT · ' + n + ' ' + UNn.toUpperCase() : '1 unidade') + '</span>' +
'<span class="hb-kf-tam">' + (tams.length === 1 ? 'Tamanho <b>' + tams[0] + '</b>'
: 'Tamanhos <b>' + tams.join(' + ') + '</b>') + '</span>' +
'</div>' +
'<div class="hb-kf-grid">' + celulas + '</div>' +
'<div class="hb-kf-out' + (semEst.length ? ' hb-kf-falta' : '') + '"><span>' +
(semEst.length
? semEst.map(function (p) { return p.cor + '/' + p.tam; }).join(', ') +
(semEst.length > 1 ? ' estão' : ' está') + ' sem estoque — troque a cor dessa peça.'
: composicaoHTML(n)) +
'</span></div></div>';
}
function kitThumb(s) {
return '<i>' + pecasDoKit(s).slice(0, 4).map(function (p) {
return '<b style="' + fotoBg(p.cor, p.p) + '"></b>';
}).join('') + '</i><em>Seu kit</em>';
}
function viewD(s) {
var c = contas(s), kit = s.oferta === 'kit' && s.mudas.length >= MIN_KIT;
var precoSolo = unPix(precoDe(s.mudas[0].cor, s.mudas[0].tam, s.mudas[0].p), pctPara(1));
var nJogos = kit ? s.mudas.length : MIN_KIT;
var unsPix, cartKit, cheioKit;
if (kit) {
unsPix = s.mudas.map(function (m) { return unPix(precoDe(m.cor, m.tam, m.p), c.pct); });
cartKit = c.totalCart; cheioKit = c.kitCheio;
} else {
var ks = COMP ? COMP.slice() : [0, 0];
var bs = ks.map(function (k) { return precoTam(tamPor(s.tamKit, k) ? s.tamKit : catK(k).tamanhos[0].nome, k); });
unsPix = bs.map(function (b) { return unPix(b, PCT_KIT); });
cartKit = bs.reduce(function (t, b) { return t + unCartao(b, PCT_KIT); }, 0);
cheioKit = bs.reduce(function (t, b) { return t + b; }, 0);
}
var precoKit = pixDoTotal(cartKit);
var pctKit = cheioKit ? Math.round((cheioKit - precoKit) / cheioKit * 100) : 0;
var uniforme = unsPix.every(function (v) { return v === unsPix[0]; });
var unKitPix = uniforme ? unsPix[0] : Math.round(precoKit / nJogos);
var linhaItem = function (i, rot, podeTirar) {
var m = s.mudas[i]; if (!m) return '';
return '<div class="hb-ditem"><span class="hb-thumb" style="' + fotoBg(m.cor, m.p) + '"></span>' +
'<span class="hb-grow"><span class="hb-dnome">' + rot + '</span><span class="hb-dsub">' + rotuloOpcoes(m.p) + '</span>' +
'<span class="hb-selwrap">' + selCor(i, m.cor, m.tam, m.p) + selTam(i, m.tam, m.p) + '</span></span>' +
(podeTirar ? '<button type="button" class="hb-del" data-act="tiraJogo" data-i="' + i +
'" aria-label="Tirar este item do kit" title="Tirar do kit">×</button>' : '') + '</div>';
};
var ROTD = function (i) { return COMP ? nomeProduto(s.mudas[i].p) : ordPt(i) + ' ' + nomeProduto(); };
var precoMais = unPix(precoTam(s.tamKit), pctPara(nJogos + 1));
var corpoKit = '<div class="hb-obody">' +
s.mudas.map(function (m, i) { return (i > 0 ? '<div class="hb-plus">+</div>' : '') + linhaItem(i, ROTD(i), i > 1); }).join('') +
'<button type="button" class="hb-addon hb-dadd" data-act="addJogo" aria-pressed="false">' +
'<span class="hb-box">+</span><span class="hb-an">Adicione mais um ' + UN1 + '</span>' +
'<span class="hb-ap">' + riscado(precoTam(s.tamKit), precoMais) + '<b class="hb-money">' + fmt(precoMais) + '</b>' + noPix() + '</span></button>' +
'</div>';
var corpoSolo = '<div class="hb-obody">' + linhaItem(0, nomeProduto()) + '</div>';
return '<div class="hb-pt-pad">' +
seletorKit(s) +
'<div class="hb-offer hb-offer-topo" data-sel="' + (kit ? 1 : 0) + '">' +
'<span class="hb-flag">MAIS ESCOLHIDO</span><span class="hb-offpct">' + pctKit + '% OFF</span>' +
'<button type="button" class="hb-ohead" data-act="oferta" data-arg="kit"><span class="hb-radio"></span>' +
'<span class="hb-on">Kit ' + nJogos + ' ' + UNn + '<small>Oferta por tempo limitado</small></span>' +
'<span class="hb-op">' + riscado(Math.round(cheioKit / nJogos), unKitPix) + '<b class="hb-money">' + fmt(unKitPix) + '<span class="hb-un">/un' + (PCT_PIX ? ' no Pix' : '') + '</span></b>' +
(uniforme ? '' : '<span class="hb-opsub">' + (COMP ? 'média do kit' : 'média · tamanhos diferentes no kit') + '</span>') + '</span>' +
'</button>' + (kit ? corpoKit : '') +
'</div>' +
'<div class="hb-offer" data-sel="' + (kit ? 0 : 1) + '">' +
'<button type="button" class="hb-ohead" data-act="oferta" data-arg="solo"><span class="hb-radio"></span>' +
'<span class="hb-on">1 ' + UN1 + ' só<small>sem desconto de kit</small></span>' +
'<span class="hb-op">' + riscado(precoDe(s.mudas[0].cor, s.mudas[0].tam, s.mudas[0].p), precoSolo) + '<b class="hb-money">' + fmt(precoSolo) + '<span class="hb-un">/un' + (PCT_PIX ? ' no Pix' : '') + '</span></b></span>' +
'</button>' + (kit ? '' : corpoSolo) +
'</div>' +
feito(s, c) +
'<button type="button" class="hb-cta" style="margin-top:14px" data-act="cta"' + (s.ocupado ? ' disabled' : '') + '>' +
(s.ocupado ? 'Adicionando…' : 'Adicionar ao carrinho') + '</button>' +
'</div>';
}
var VISTAS = { D: viewD };
var CATS = [];
if (typeof CAT === 'undefined') var CAT = null;
var ANCORA_EL = null;
var GATILHO_MEDIDAS = null;
var T0 = Date.now();
var ANCORAS = ['pdp-bundle', '.buy-buttons-block'];
function achaAncora() {
for (var i = 0; i < ANCORAS.length; i++) {
var el = document.querySelector(ANCORAS[i]);
if (el) return { el: el, tipo: i === 0 ? 'bundle' : 'nativo' };
}
return null;
}
function esperaAncora(tetoMs, cb) {
esperaVisivel(ANCORAS.join(','), tetoMs, function () { cb(achaAncora()); });
}
var TRACE = [];
function marca(o, extra) {
TRACE.push({ t: Date.now() - T0, o: o, x: extra || null });
window.__hbTrace = TRACE;
try {
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({ event: 'hb_bundle', hb_etapa: o, hb_var: CFG.rotulo, hb_pagina: CFG.pagina });
} catch (e) { }
}
function seloPintado(el) {
var alvo = el.querySelector('.pdp-bundle__summary') || el;
var txt = (alvo.innerText || alvo.textContent || '');
var re = /(\d{1,2})\s*%\s*off/gi, m, vistos = {};
while ((m = re.exec(txt))) vistos[m[1]] = 1;
var ks = Object.keys(vistos);
if (!ks.length) return null;
return ks.length === 1 ? parseInt(ks[0], 10) : 0;
}
function desiste(motivo, extra) {
marca('desiste:' + motivo, extra);
try { document.documentElement.classList.remove('hb-ok'); } catch (e) { }
try {
var st = document.getElementById('hb-antiflash');
if (st && st.parentNode) st.parentNode.removeChild(st);
} catch (e) { }
}
function noLugar() {
var p = location.pathname.replace(/\/+$/, '');
if (CFG.caminho) return p === CFG.caminho;
if (CFG.alvo) return new RegExp(CFG.alvo).test(p);
return false;
}
function idDoPainel(col) {
if (!col || !col.querySelector) return null;
var f = col.querySelector('product-form-component[data-product-id]');
var id = f && f.getAttribute('data-product-id');
return id ? String(id) : null;
}
var CSS_ANTIFLASH =
'pdp-bundle,product-price,variant-picker,.buy-buttons-block' +
'{visibility:hidden;animation:hb-revela 2200ms steps(1,end) both}' +
'@keyframes hb-revela{from{visibility:hidden}to{visibility:visible}}' +
'html.hb-ok pdp-bundle,html.hb-ok product-price,html.hb-ok variant-picker,' +
'html.hb-ok .buy-buttons-block{display:none!important;animation:none}' +
'html.hb-ok .hb-oculto{display:none!important}';
function poeEstilo(id, css) {
if (document.getElementById(id)) return;
var st = document.createElement('style');
st.id = id; st.textContent = css;
(document.head || document.documentElement).appendChild(st);
}
function esperaVisivel(seletor, tetoMs, cb) {
var visto = 0, ultimo = Date.now(), pronto = false;
var achar = function () { return document.querySelector(seletor); };
var fim = function (el) {
if (pronto) return; pronto = true;
if (obs) obs.disconnect(); clearInterval(iv);
document.removeEventListener('visibilitychange', vis);
cb(el || null);
};
var conta = function () {
var agora = Date.now();
if (document.visibilityState !== 'hidden') visto += agora - ultimo;
ultimo = agora;
return visto;
};
var vis = function () { conta(); };
document.addEventListener('visibilitychange', vis);
var tenta = function () {
var el = achar();
if (el) return fim(el);
if (conta() >= tetoMs) fim(null);
};
var obs = new MutationObserver(tenta);
try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) { obs = null; }
var iv = setInterval(tenta, 150);
tenta();
}
var COMP_PEND = null;
function composicaoDoPadrao(anc, pid) {
if (!anc || anc.tipo !== 'bundle') return null;
var prods = window.produtosBundle, itens = anc.el && anc.el.bundleItems;
if (!prods || !prods.length) return null;
var exp = [];
for (var i = 0; i < prods.length; i++) {
var q = +((itens && itens[i] && itens[i].quantidade) || 1) || 1;
for (var j = 0; j < q; j++) exp.push(prods[i]);
}
var ids = [];
exp.forEach(function (p) { if (ids.indexOf(String(p.id)) < 0) ids.push(String(p.id)); });
if (ids.length < 2) return null;
if (ids.indexOf(String(pid)) < 0) return null;
ids.sort(function (a, b) { return (a === String(pid) ? -1 : 0) - (b === String(pid) ? -1 : 0); });
var lista = ids.map(function (id) {
for (var k = 0; k < exp.length; k++) if (String(exp[k].id) === id) return { handle: exp[k].handle, id: id };
return null;
});
var idx = exp.map(function (p) { return ids.indexOf(String(p.id)); }).sort(function (a, b) { return a - b; });
return { lista: lista, idx: idx, rotulo: lista.map(function (x) { return x.handle; }).join('+') + ' [' + idx.join(',') + ']' };
}
function pegaProdutos(lista, cb) {
var faltam = lista.length, erro = false, saida = [];
if (!faltam) return cb(null);
lista.forEach(function (p, i) {
fetch('/products/' + p.handle + '.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
.then(function (j) {
var op = (p.iCor != null) ? { iCor: p.iCor, iTam: (p.iTam === undefined ? null : p.iTam), ok: true }
: descobreOpcoes(j);
if (!op.ok) throw new Error('opcoes_desconhecidas');
saida[i] = catalogo(j, op.iCor, op.iTam, op.iMod == null ? null : op.iMod);
})
.catch(function (e) { erro = true; marca('fetch_falhou', p.handle + ' ' + e.message); })
.then(function () { if (--faltam === 0) cb(erro ? null : saida); });
});
}
function linhasDoKit(s) {
var mapa = {}, ordem = [];
itensDoCarrinho(s).forEach(function (it) {
if (!it || !it.id) return;
if (!mapa[it.id]) { mapa[it.id] = { id: it.id, quantity: 0 }; if (CFG.props) mapa[it.id].properties = CFG.props; ordem.push(it.id); }
mapa[it.id].quantity += (it.quantity || 1);
});
return ordem.map(function (id) { return mapa[id]; });
}
function abreCarrinho(resp, itens) {
try {
if (window.CartAddEvent) {
var qtd = itens.reduce(function (t, v) { return t + v.quantity; }, 0);
document.dispatchEvent(new window.CartAddEvent(resp || {}, String(itens[0] && itens[0].id || ''), {
source: 'product-form-component', itemCount: qtd, productId: String(CAT.pid || '')
}));
marca('drawer');
return;
}
} catch (e) { marca('drawer_falhou', e && e.message); }
location.href = '/cart';
}
function adicionar(s, pintar) {
var itens = linhasDoKit(s);
if (!itens.length) { s.erro = 'Escolha as opções antes de adicionar.'; pintar(); return; }
s.ocupado = true; s.erro = null; pintar();
marca('add_envia', itens.map(function (x) { return x.id + 'x' + x.quantity; }).join(','));
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: itens })
}).then(function (r) {
if (!r.ok) return r.text().then(function (t) { throw new Error(r.status + ' ' + t.slice(0, 120)); });
return r.json();
}).then(function (resp) {
s.ocupado = false; s.adicionado = true; marca('add_ok'); pintar();
abreCarrinho(resp, itens);
}).catch(function (e) {
s.ocupado = false;
s.erro = 'Não foi possível adicionar agora — tente novamente.';
marca('add_falhou', e.message); pintar();
});
}
function fotosDoTema() {
var media = document.querySelector('.product-information__media');
if (!media) return [];
var fotos = [], vistos = {};
var imgs = media.querySelectorAll('img');
for (var i = 0; i < imgs.length; i++) {
var u = imgs[i].currentSrc || imgs[i].src;
if (!u || u.indexOf('data:') === 0) continue;
u = u.replace(/([?&])width=\d+/, '$1width=1100');
if (!vistos[u]) { vistos[u] = 1; fotos.push(u); }
if (fotos.length >= 6) break;
}
return fotos;
}
function galeriaHTML(s, fotos) {
var i = s.gal || 0;
var hero = (i === 0) ? kitViz(s)
: '<span class="hb-kf-foto" style="background-image:url(' + fotos[i - 1] + ')"></span>';
var thumbs = '<div class="hb-thumbs">' +
'<button type="button" class="hb-tkit" data-act="gal" data-arg="0" aria-pressed="' + (i === 0) + '" title="O kit montado">' +
kitThumb(s) + '</button>' +
fotos.map(function (f, k) {
return '<button type="button" data-act="gal" data-arg="' + (k + 1) + '" aria-pressed="' + (i === k + 1) + '"' +
' style="background-image:url(' + f.replace(/([?&])width=\d+/, '$1width=160') + ')" aria-label="Foto ' + (k + 1) + '"></button>';
}).join('') + '</div>';
return hero + thumbs;
}
function leSwatchesDoTema(col) {
var mapa = {};
try {
var labels = (col || document).querySelectorAll('label.variant-option__button-label');
for (var i = 0; i < labels.length; i++) {
var l = labels[i], inp = l.querySelector('input');
if (!inp) continue;
var nome = inp.getAttribute('value') || inp.getAttribute('aria-label');
if (!nome || mapa[nome]) continue;
var sw = l.querySelector('.swatch'), est = sw && sw.getAttribute('style');
mapa[nome] = {
bg: (est && est.indexOf('--swatch-background') >= 0) ? est : null,
novo: !!l.querySelector('[class*="new-badge"]')
};
}
} catch (e) { }
return mapa;
}
var GAL_SEQ = 0, GAL_ULT = null;
function achaGaleria() {
var sec = (ANCORA_EL && ANCORA_EL.closest) ? ANCORA_EL.closest('.shopify-section') : null;
return (sec && sec.querySelector('media-gallery')) || document.querySelector('media-gallery');
}
function sincronizaGaleria(s) {
if (!CAT || !s || !s.mudas || !s.mudas.length) return;
var m = s.mudas[Math.min(s.foco || 0, s.mudas.length - 1)];
if (m.p) return;                  // kit misto: a galeria do tema é do produto da página
var v = vidDe(m.cor, m.tam);
if (!v || v === GAL_ULT) return;
GAL_ULT = v;
var seq = ++GAL_SEQ;
fetch('/products/' + CAT.handle + '?variant=' + v, { headers: { 'Accept': 'text/html' } })
.then(function (r) { return r.ok ? r.text() : null; })
.then(function (txt) {
if (!txt || seq !== GAL_SEQ) return;
var doc = new DOMParser().parseFromString(txt, 'text/html');
var gal = achaGaleria();
if (!gal || !doc.querySelector('media-gallery')) return marca('galeria_sem_alvo');
gal.dispatchEvent(new CustomEvent('variant:update', {
bubbles: true,
detail: {
resource: { id: v }, sourceId: 'hb-bundle',
data: { html: doc, productId: String(CAT.pid), newProduct: undefined }
}
}));
marca('galeria', m.cor + ' / ' + m.tam);
})
.catch(function (e) { marca('galeria_falhou', e && e.message); });
}
function preparaMedidas(col) {
try {
var gat = (col || document).querySelector('[data-size-chart-trigger]');
if (!gat) return false;
var modal = document.getElementById('size-chart-modal');
if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
GATILHO_MEDIDAS = gat;
return true;
} catch (e) { return false; }
}
function monta(anc, col, cats) {
var alvo = anc && anc.el;
var bloco = alvo && (alvo.closest('.shopify-block') || alvo.parentElement);
if (!alvo || !bloco || !col) return desiste('sem_alvo');
ANCORA_EL = alvo;
if (typeof SWTEMA !== 'undefined') SWTEMA = leSwatchesDoTema(col);
if (typeof TEM_MEDIDAS !== 'undefined') TEM_MEDIDAS = preparaMedidas(col);
CATS = cats; CAT = cats[0];
if (COMP_PEND && typeof COMP !== 'undefined') COMP = COMP_PEND;
if (!CAT || !CAT.cores.length || !CAT.tamanhos.length) return desiste('catalogo_vazio');
for (var q = 0; q < CATS.length; q++) if (!CATS[q] || !CATS[q].cores.length) return desiste('catalogo_vazio');
var s = novoEstado(CFG.braco);
if (s.mudas && typeof vidDe === 'function') GAL_ULT = vidDe(s.mudas[0].cor, s.mudas[0].tam);   // só no modo lençol
var kids = col.children, marcados = 0;
if (anc.tipo === 'nativo' || CFG.cabecalho === 'tema') { bloco.classList.add('hb-oculto'); marcados = 1; }
else for (var n = 0; n < kids.length; n++) {
var c = kids[n];
if (c === bloco) { c.classList.add('hb-oculto'); marcados++; break; }
if (c.tagName === 'SCRIPT' || c.tagName === 'STYLE') continue;
c.classList.add('hb-oculto'); marcados++;
}
var app = document.createElement('div');
app.id = 'hb-app'; app.className = 'hb-root';
app.setAttribute('data-hb', CFG.rotulo);
var pt = document.createElement('div');
pt.className = 'hb-pt';
app.appendChild(pt);
bloco.parentNode.insertBefore(app, bloco.nextSibling);
var media = CFG.galeria === 'kit' ? document.querySelector('.product-information__media') : null;
var slide = media && media.querySelector('slideshow-component');
var gal = null, fotos = [];
if (media && slide) {
fotos = fotosDoTema();
gal = document.createElement('div');
gal.id = 'hb-gal'; gal.className = 'hb-root';
slide.parentNode.insertBefore(gal, slide);
slide.classList.add('hb-oculto');
var selo = media.querySelector('.guarantee-badge');
if (selo) {
var rs = selo.getBoundingClientRect(), rg = gal.getBoundingClientRect();
var folga = Math.round(rs.bottom - rg.top + 10);
if (folga > 0 && folga < 200) gal.style.paddingTop = folga + 'px';
}
}
var pintar = function () {
pt.innerHTML = VISTAS[CFG.braco](s);
if (gal) gal.innerHTML = galeriaHTML(s, fotos);
};
// Captação de variante esgotada (16/10/2026, Thiago: "a captação funcione em todas"): o form do tema
// (#waitlist-capture, que mora no bloco que o painel esconde) vem pra baixo do painel e recebe a variante.
var esgotada = function () {
var pc = pecasDoKit(s);
for (var k = 0; k < pc.length; k++) if (pc[k].cor && !disp(pc[k].cor, pc[k].tam, pc[k].p)) return pc[k];
return null;
};
var captacao = function () {
var wl = document.getElementById('waitlist-capture'), e = esgotada();
app.classList.toggle('hb-esgotado', !!e);
if (!wl) return;
if (!e) { wl.classList.remove('is-active'); return; }
var c = corPor(e.cor, e.p) || {};
if (wl.parentNode !== app) {
app.appendChild(wl);
// o bloco escondido (pdp-bundle/buy-buttons) também ouve a troca de variante e "limpa" o form: enquanto o
// painel está esgotado, quem manda é o painel
new MutationObserver(function () {
if (app.classList.contains('hb-esgotado') && !wl.classList.contains('is-active')) wl.classList.add('is-active');
}).observe(wl, { attributes: true, attributeFilter: ['class'] });
}
wl.dataset.variantId = String((c.vid || {})[e.tam] || '');
wl.dataset.sku = (c.sku || {})[e.tam] || '';
wl.dataset.variantOptions = JSON.stringify(e.tam && e.tam !== 'Único' ? { Cor: e.cor, Tamanho: e.tam } : { Cor: e.cor });
wl.classList.add('is-active');
marca('esgotada', e.cor + '/' + e.tam);
};
var trata = function (act, arg, i) {
if (act === 'gal') { s.gal = +arg; pintar(); return; }
if (act === 'cta' && esgotada()) { captacao(); return; }
if (act === 'medidas') { if (GATILHO_MEDIDAS) GATILHO_MEDIDAS.click(); return; }
var r = acao(s, act, arg, i);
pintar();
sincronizaGaleria(s);
captacao();
if (r === 'add') adicionar(s, pintar);
};
[app, gal].forEach(function (raiz) {
if (!raiz) return;
raiz.addEventListener('click', function (ev) {
var t = ev.target;
if (t.tagName === 'SELECT' || t.tagName === 'OPTION') return;
var b = t.closest('[data-act]');
if (!b || b.disabled || b.tagName === 'SELECT') return;
ev.preventDefault();
trata(b.getAttribute('data-act'), b.getAttribute('data-arg'), b.getAttribute('data-i'));
});
raiz.addEventListener('change', function (ev) {
var sel = ev.target.closest('select[data-act]');
if (!sel) return;
trata(sel.getAttribute('data-act'), sel.value, sel.getAttribute('data-i'));
});
});
pintar();
captacao();
document.documentElement.classList.add('hb-ok');
marca('montou', 'ocultos:' + marcados + ' fotos:' + fotos.length);
window.__hb = { s: s, pintar: pintar, cat: CAT, cfg: CFG, contas: function () { return contas(s); }, linhas: function () { return linhasDoKit(s); } };
}
function boot() {
if (!noLugar()) return;
if (window.__hbBoot) return; window.__hbBoot = 1;
marca('boot');
aplicaPix();
marca('pix', PCT_PIX + '%');
var t = autoTeste();
if (!t.ok) return desiste('motor', t.falhas.join(' | '));   // sem preço confiável, não pinta
marca('motor_ok', t.n + '/' + t.total);
poeEstilo('hb-antiflash', CSS_ANTIFLASH);
poeEstilo('hb-estilo', CSS_PAINEL);
esperaAncora(5000, function (anc) {
if (!anc) return desiste('alvo_nao_apareceu');
marca('ancora', anc.tipo);
var col = anc.el.closest('.group-block-content') || anc.el.closest('.shopify-block') || anc.el.parentElement;
var lista = CFG.produtos;
if (!lista || !lista.length) {
var pid = idDoPainel(anc.el) || idDoPainel(col);
if (!pid) return desiste('sem_produto');
var f = FAIXAS[pid];
if (!f) return desiste('sem_faixa', pid);
lista = [{ handle: f.h, id: pid }];
marca('produto', f.h + ' (' + pid + ')');
var comp = composicaoDoPadrao(anc, pid);
if (comp) { lista = comp.lista; COMP_PEND = comp.idx; marca('composicao', comp.rotulo); }
}
var pctAnterior = null;
for (var i = 0; i < lista.length; i++) {
var chave = lista[i].id || idPorHandle(lista[i].handle);
if (!aplicaFaixa(chave)) return desiste('sem_faixa', lista[i].handle);
if (pctAnterior != null && pctAnterior !== PCT_KIT) return desiste('faixa_divergente', lista[i].handle);
pctAnterior = PCT_KIT;
}
marca('faixa', PCT_KIT + '% min ' + MIN_KIT);
if (anc.tipo === 'bundle') {
var vd = seloPintado(anc.el);
if (vd != null) marca('selo_pintado', vd + '%');
else vd = parseInt(anc.el.getAttribute('data-visual-discount'), 10);
if (vd === 0) return desiste('selo_ambiguo', 'resumo do controle com dois percentuais');
if (vd && vd !== pctAte()) {
marca('selo_do_tema_diverge', vd + ' no tema x ' + pctAte() + ' no motor');
if (CFG.alvo && pctAte() > vd) return desiste('selo_divergente', vd + ' no tema x ' + pctAte() + ' no motor');
}
}
pegaProdutos(lista, function (cats) {
if (!cats) return desiste('fetch');
marca('catalogo_ok');
try { monta(anc, col, cats); } catch (e) { desiste('erro_monta', e && e.message); }
});
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
boot();
})();
